import { Button, Input } from '@calizahq/react-components-v2'
import { Form, Formik } from 'formik'
import React from 'react'

import { useAlertContext } from '@/context'
import { ReservationMutations } from '@/graphql/mutations/reservations.mutations'
import { useGraphqlMutation } from '@/hooks/useGraphql'
import { HomeQualityCheckReservation } from '@/types/HomeQualityCheck'

import { FormValuesType } from './UpdateAccessCodes.util'

type Props = {
  closeModal: () => void
  refetchOnSuccess?(): void
  reservation: HomeQualityCheckReservation
}

export const UpdateReservationAccessCodes = ({ reservation, refetchOnSuccess, closeModal }: Props) => {
  const { setAlert } = useAlertContext()
  const { mutate, isPending: isLoading } = useGraphqlMutation(ReservationMutations.updateReservation(), {
    onSuccess: () => {
      setAlert('Reservation Access Codes updated!', 'success')
      refetchOnSuccess && refetchOnSuccess()
      closeModal()
    },
  })

  const handleSubmit = (values: FormValuesType) => {
    let update_reservation = {
      id: reservation.id,
      ...(!!values?.hostDoorAccessCode && { hostDoorAccessCode: values.hostDoorAccessCode }),
      ...(!!values?.intercomCode && { intercomCode: values.intercomCode }),
      ...(!!values?.lockboxBackupCode && { lockboxBackupCode: values.lockboxBackupCode }),
      ...(!!values?.lockboxCode && { lockboxCode: values.lockboxCode }),
      ...(!!values?.memberDoorAccessCode && { memberDoorAccessCode: values.memberDoorAccessCode }),
    }
    mutate({ reservation: update_reservation })
  }

  return (
    <Formik
      initialValues={{
        hostDoorAccessCode: reservation.hostDoorAccessCode || '',
        intercomCode: reservation.intercomCode || '',
        lockboxBackupCode: reservation.lockboxBackupCode || '',
        lockboxCode: reservation.lockboxCode || '',
        memberDoorAccessCode: reservation.memberDoorAccessCode || '',
      }}
      onSubmit={handleSubmit}
    >
      <Form className="flex flex-wrap px-4 md:px-8  md:max-w-120">
        <div className="flex flex-row w-full mb-4">
          <Input className="w-full" id="hostDoorAccessCode" label="Host Door Access Code" name="hostDoorAccessCode" />
        </div>
        <div className="flex flex-row w-full mb-4">
          <Input
            className="w-full"
            id="memberDoorAccessCode"
            label="Member Door Access Code"
            name="memberDoorAccessCode"
          />
        </div>
        <div className="flex flex-row w-full mb-4">
          <Input className="w-full" id="lockboxCode" label="Lockbox Code" name="lockboxCode" />
        </div>
        <div className="flex flex-row w-full mb-4">
          <Input className="w-full" id="lockboxBackupCode" label="Lockbox Backup Code" name="lockboxBackupCode" />
        </div>
        <div className="flex flex-row w-full mb-4">
          <Input className="w-full" id="intercomCode" label="Intercom Code" name="intercomCode" />
        </div>

        <Button className=" w-full bg-text-semantic-success" disabled={isLoading} isLoading={isLoading} type="submit">
          Submit
        </Button>
      </Form>
    </Formik>
  )
}
